import React, { useState, useRef, useEffect } from "react";
import "./createBanners.scss";
import Cookies from 'js-cookie';
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { decode } from "base-64";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { useNavigate } from "react-router-dom";
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { CreateBannerImageAction } from "../../actions/bannerAction";
import useMobileView from "../../constants/useMobileView";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";


function CreateBanners() {
  const [states, setStates] = useState({
    name: "",
    banner_type: "",
    redirect_url: "",
    banner_image: "",
    start_date: "",
    end_date: "",
  })
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImageSrc, setPreviewImageSrc] = useState(null);
  const { isSidebarOpen, toggleSidebar } = useMobileView();


  const fileInputRefs = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setloading] = useState(false);
  const BannerType = ["Top", "Bottom"]
  const today = new Date().toISOString().split("T")[0];
  var vehicleType = Cookies.get('vehicletype') ? Cookies.get('vehicletype') : "";
  if (vehicleType) {
    vehicleType = decode(vehicleType)
  }
  const is3w = () => {
    return vehicleType == "3W"
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const previewImageSrc = reader.result;
        setPreviewImageSrc(previewImageSrc);
        setSelectedImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const onCloseButtonClick = () => {
    navigate('/banners')
  }
  const handleChange = (evt) => {
    const value = evt.target.value;
    setStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };

  const handleBannerTypeChange = (event) => {
    const selectedType = event.target.value;
    setStates({ ...states, banner_type: selectedType });
  };


  const handleOnSaveClick = async (e) => {
    e.preventDefault();
    // const urlValidationRegex = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,})(\/[\w .-]*)*\/?$/;
    // const urlValidationRegex = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,})(\/[\w .-]*)*\/?$/i;
    // if (states.redirect_url && !urlValidationRegex.test(states.redirect_url)) {
    //   notify.error("Invalid URL entered");
    //   return false;
    // }

    // Validate required fields
    if (!states.name || !states.banner_type || !selectedImage) {
      notify.error("Please fill in all required fields");
      return false;
    }
    
    // Validate date fields for 3W users
    if (is3w()) {
      if (!states.start_date || !states.end_date) {
        notify.error("Date fields are required for 3W users");
        return false;
      }
      
      // Validate that to_date is after from_date
      if (new Date(states.end_date) <= new Date(states.start_date)) {
        notify.error("To Date must be after From Date");
        return false;
      }
    }

    setloading(true);
    const apiReq = {
      name: states.name,
      banner_type: states.banner_type.toLowerCase(),
      redirect_url: states.redirect_url,
      banner_image: selectedImage,
    }
    // Include date fields for 3W users
    if (is3w()) {
      apiReq.start_date = states.start_date;
      apiReq.end_date = states.end_date;
    }
        
    let response = await dispatch(CreateBannerImageAction(apiReq));
    if (response?.status === HTTP_STATUS.CREATED) {
      notify.success("Banner image created")
      setloading(false);
      navigate("/banners")
    } else if (response === undefined) {
      setloading(false);
    }
  }

   // Determine if the save button should be disabled
   const isSaveDisabled = () => {
    const basicRequirements = !states.name || selectedImage === null || !states.banner_type;
    
    // Add date validation for 3W users
    if (is3w()) {
      return basicRequirements || !states.start_date || !states.end_date;
    }
    
    return basicRequirements;
  };

  return (
    <div className="banners-container">
      <div className="banners-container-right">
        <Header title="Create Banners" />
        <div className="banners-container-create">
          {isLoading ? (
            <Loader />
          ) : (
            <form>
              <div className="grid date">
                <label className="label-create-banners">Select Banner Type</label>
                <select
                  value={states.banner_type}
                  onChange={handleBannerTypeChange}
                  className="create-banners-input"
                >
                  <option value="">Select banner type</option>
                  {BannerType.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="grid date">
                <label className="label-create-banners">Title</label>
                <input
                  className="create-banners-input"
                  type="text"
                  name="name"
                  value={states.name}
                  onChange={handleChange}
                />
              </div>
              {is3w() &&
                (
                  <>
                    <div className="grid date">
                      <label className="label-create-banners">From Date</label>
                      <input
                        className="create-banners-input"
                        id="date"
                        placeholder="dd/mm/yy"
                        type="date"
                        name="start_date"
                        min={today}
                        value={states.start_date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="grid date">
                      <label className="label-create-banners">To Date</label>
                      <input
                        className="create-banners-input"
                        id="date"
                        placeholder="dd/mm/yy"
                        type="date"
                        name="end_date"
                        min={today}
                        value={states.end_date}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )
              }
              <div className="grid">
                <label className="label-create-banners">Image Upload</label>
                <label
                  onChange={handleImageUpload}
                  htmlFor="banner_image"
                  className="image-upload-label"
                >
                  <input
                    type="file"
                    className="create-banners-input"
                    name="banner_image"
                    id="banner_image"
                    accept="image/*"
                    hidden
                    ref={fileInputRefs}
                    onChange={handleImageUpload}
                  />
                  Choose File
                </label>
              </div>
              <span className="banner_image_message">The image size should  be 1000*600</span>
              {selectedImage && (
                <div className="create-banner-uploaded-img">
                  {/* Display a preview of the selected image if needed */}
                  <img src={previewImageSrc} className="create-banners-upload" alt="Preview" height="100px" width="100px" />
                  {/* <p>Selected Image: {selectedImage.name}</p> */}
                </div>
              )}
              <div className="grid">
                <label className="label-create-banners-url">Redirect Url</label>
                <input
                  type="text"
                  className="create_banners_url"
                  name="redirect_url"
                  value={states.redirect_url}
                  onChange={handleChange}
                />
              </div>
              <div className="btn-create-banners">
                <button className="create-banners-active" onClick={onCloseButtonClick}>Close</button>
                <button
                  className="create-banners-active"
                  disabled={isSaveDisabled()}
                  onClick={handleOnSaveClick}
                >
                  Save
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
export default CreateBanners;